import {texts} from '../../../../texts';

export type TlanguageTabsId = (typeof languageTabs)[number]['id'];

export const languageTabs = [
    {
        title: texts.english_lang_tab,
        lang: 'eng',
        id: '3'
    },
    {
        title: texts.hebrew_lang_tab,
        lang: 'he',
        id: '1'
    }
] as const;
